import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from './notification.service';
import { UserService } from './user.service';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  private router = inject(Router);
  private userService = inject(UserService);
  private notificationService = inject(NotificationService);
  private translateService = inject(TranslateService);
  constructor() {}

handleError(err: HttpErrorResponse | any): void {
  let errorMessage = '';
  let errorTitle = '';

  if (err.error instanceof ErrorEvent) {
    errorTitle = 'Error';
    errorMessage = this.translateService.instant('COMMONS.ERROR.EVENT', err.error.message);
    this.notificationService.error(errorMessage, errorTitle);
    return;
  }

  switch (err.status) {
    case 401:
      errorTitle = 'Error 401';
      errorMessage = this.getErrorMessage(err);
      this.notificationService.error(errorMessage, errorTitle);
      this.redirect();
      return;

    case 404:
      console.warn('404 Not Found', err);
      return;

    case 400:
    case 403:
    case 412:
    case 500:
    case 503:
      errorTitle = `Error ${err.status}`;
      errorMessage = this.getErrorMessage(err);
      this.notificationService.error(errorMessage, errorTitle);
      return;

    default:
      if (err.body?.ResponseStatus) {
        const { errorTitle, errorMessage } = this.getErrors(err);
        this.notificationService.error(errorMessage, errorTitle);
      } else if (err.error?.responseStatus?.message) {
        errorTitle = 'Error';
        errorMessage = err.error.responseStatus.message;
        this.notificationService.error(errorMessage, errorTitle);
      } else if (err.message) {
        errorTitle = 'Error';
        errorMessage = err.message;
        this.notificationService.error(errorMessage, errorTitle);
      }
  }
}


  private getErrorMessage(err: any): string {
    return err.error?.responseStatus?.message
      ? err.error?.responseStatus?.message
      : this.translateService.instant(`COMMONS.ERROR.${err.status}`, {
          status: err.status,
        });
  }

  private getErrors(err: any): { errorTitle: string; errorMessage: string } {
    let errorTitle: string;
    let errorMessage: string = '';

    if (err.body.ResponseStatus?.Message) {
      errorTitle = `Error ${err.body.StatusCode}`;
      errorMessage = err.body.ResponseStatus?.Message;
    } else {
      errorTitle = `Error`;
      if (err.body.ResponseStatus?.Errors.length > 1) {
        err.body.ResponseStatus?.Errors.forEach((e: any) => {
          errorMessage += e.Message;
        });
      } else {
        errorMessage = err.body.ResponseStatus?.Errors[0]?.Message;
      }
    }

    return { errorTitle, errorMessage };
  }

  private redirect() {
    this.router.navigate(['auth', 'tenant', this.userService.getAppId()]);
    this.userService.logout();
  }
}
